import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

const baseUrl = environment.apiAuthBaseUrl;
const apiOtpBaseUrl = environment.apiOtpBaseUrl;
const apiAuthBaseUrl = environment.apiAuthBaseUrl;

export interface RegisterPayload {
  email: string;
  password: string;
}

export interface LoginPayload {
  authentifier: string;
  password: string;
  send: boolean;
}

export interface ConfirmPassword {
  Authentifier: string | null;
  Password: string;
  Token: string | null;
}

export interface CheckOtp {
  sessionids: string | null | undefined;
  otp: string | null | undefined;
}

export interface ResetPassword {
  Authentifier: string;
}

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private readonly http = inject(HttpClient);

  register(payload: RegisterPayload): Observable<unknown> {
    return this.http.post(`${baseUrl}/register`, payload);
  }

  login(payload: LoginPayload): Observable<unknown> {
    return this.http.post(`${apiOtpBaseUrl}/otp/loginselect`, payload, {
      withCredentials: true,
    });
  }

  checkOtp(checkOtp: CheckOtp): Observable<any> {
    return this.http.post<any>(`${apiOtpBaseUrl}/otp/check`, checkOtp, {
      withCredentials: true,
    });
  }

  initResetPassword(resetPassword: ResetPassword): Observable<any> {
    return this.http.post<any>(`${apiOtpBaseUrl}/lost-password/getUser`, resetPassword);
  }

  confirmResetPassword(confirmPassword: ConfirmPassword): Observable<any> {
    return this.http.post<any>(`${apiOtpBaseUrl}/lost-password/changePassword`, confirmPassword, {
      withCredentials: true,
    });
  }
}
